import type { Step } from "react-joyride";

export const otSummaryTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າສະຫຼຸບ OT ຕາມເດືອນ. ເບິ່ງຊົ່ວໂມງ OT ລວມຕໍ່ພະນັກງານໃນແຕ່ລະເດືອນ ເພື່ອຄິດເງິນເດືອນ ແລະ ຮັບເງິນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="ot-summary-toolbar"]',
    content:
      "ເລືອກປີ ແລະ ເດືອນ, ເບິ່ງສະຫຼຸບ, ເປີດ Payroll ຫຼື ສົ່ງອອກ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-summary-table"]',
    content:
      "ຕາຕະລາງສະຫຼຸບ: ພະນັກງານ, ແຜ່ນການ, ຕຳແໜ່ງ ແລະ ຊົ່ວໂມງ OT ລວມ. ກົດ 'ເບິ່ງລາຍລະອຽດ' ເພື່ອໄປຫນ້າອະນຸມັດກັ່ນຕອງຕາມພະນັກງານ.",
    placement: "top",
  },
];
